import React from 'react';
import ReactPaginate from 'react-paginate';
import Icon from '../Icon';
import Loader from '../UI/Loader/Loader';

function Table(props) {
  const rows = props.tableData;
  const handlePageClick = (event) => {
    // const newOffset = (event.selected * itemsPerPage) % items.length;
    // console.log(
    //   `User requested page number ${event.selected}, which is offset ${newOffset}`
    // );
    // setItemOffset(newOffset);
    props.setPage(event.selected + 1);
  };

  return (
    <div className='drop-shadow-md overflow-auto relative w-[70vw]  mx-auto rounded-xl'>
      <table className='w-full relative bg-white'>
        <thead className='bg-gray-50 border-b-2 sticky top-0 w-full border-gray-200'>
          <tr>
            {
              // Loop over the headers in each row
              props.tableHead.map((column, id) => (
                // Apply the header cell props
                <th
                  className={`p-3 w-24 text-base whitespace-nowrap  text-greyPrimary font-semibold tracking-wide text-left`}
                  key={id}
                >
                  {column}
                </th>
              ))
            }
          </tr>
        </thead>

        <tbody className='divide-y  divide-gray-100'>
          {!rows && (
            <tr className='bg-white h-[15rem] relative text-sm text-greyPrimary w-full p-4'>
              <td className='absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'>
                <Loader />
              </td>
            </tr>
          )}
          {rows && rows.length === 0 && (
            <tr className='bg-white h-[15rem] relative text-sm text-greyPrimary w-full p-4'>
              <td className='absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'>
                No data found
              </td>
            </tr>
          )}
          {rows &&
            rows.map((el, id) => {
              return (
                <tr className='bg-white' key={id}>
                  {el.map((item, id) => {
                    return (
                      <td
                        key={id}
                        className='p-3 font-semibold text-sm text-gray-700 whitespace-nowrap'
                      >
                        {item}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
      </table>

      {/* BOTTOM BUTTONS */}
      <div className='sticky p-2 bottom-0 left-0 w-full bg-white'>
        {
          <ReactPaginate
            breakLabel='...'
            nextLabel={
              <div className='w-8 h-8 hover:bg-gray-100 flex items-center justify-center border-r-[1px] border-y-[1px]'>
                <Icon name='arrowRight' className='w-4 h-4 fill-gray-700' />
              </div>
            }
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            pageCount={Math.ceil(props.totalPage / props.productLimit)}
            previousLabel={
              <div className='w-8 h-8 hover:bg-gray-100 flex items-center justify-center border-x-[1px] border-y-[1px]'>
                <Icon name='arrowLeft' className='w-4 h-4 fill-gray-700' />
              </div>
            }
            renderOnZeroPageCount={null}
            containerClassName='flex items-center ml-auto w-min'
            pageLinkClassName='h-8 w-8  text-sm text-gray-700 flex items-center justify-center border-r-[1px] border-y-[1px]'
            activeClassName='bg-blue-500 block  text-red-100 font-bold'
            activeLinkClassName='block w-full  text-red-100 h-full'
          />
        }
      </div>
    </div>
  );
}

export default Table;
